module.exports = __webpack_public_path__ + "static/media/gifi1.12c1a7d4.jpg";